import { defineMessages } from 'react-intl';

export const downgradeReconsiderModalMessages = defineMessages({
  evidenceTitle: {
    defaultMessage: 'You’re about to lose source control',
    id: 'OBA9y4VUAp',
    description: 'Title when downgrading from Evidence Pro trial',
  },
  evidenceSubtitle: {
    defaultMessage:
      'You’ve used source control {count, plural, one {# time} other {# times}}. You will lose this and other popular features if you downgrade.',
    id: 'agiuqlD/eC',
    description: 'Subtitle for Evidence Pro downgrade with source control usage count',
  },
  clinicianTitle: {
    defaultMessage: 'You’re about to lose unlimited custom templates',
    id: 'bjKjNjT7Yj',
    description: 'Title when downgrading from Clinician trial',
  },
  clinicianSubtitle: {
    defaultMessage:
      'You’ve used unlimited custom templates {count, plural, one {# time} other {# times}}. You will lose this and other popular features if you downgrade.',
    id: 'IiQ8yCbUQ2',
    description: 'Subtitle for Clinician downgrade with custom templates usage count',
  },
  practiceTitle: {
    defaultMessage: 'You’re about to lose team access and collaboration',
    id: 'XzCK655eTu',
    description: 'Title when downgrading from Practice trial',
  },
  practiceSubtitle: {
    defaultMessage:
      '{count, plural, one {# team member is} other {# team members are}} using Heidi together. They will lose access to popular features if you downgrade.',
    id: '5hhOYWgn7w',
    description: 'Subtitle for Practice downgrade with team member count',
  },
  downgradeButton: {
    defaultMessage: 'Downgrade',
    id: 'ZHZib+K4a0',
    description: 'Primary destructive action to confirm plan downgrade',
  },
  goBackButton: {
    defaultMessage: 'Go back',
    id: 'voG1ehLB8i',
    description: 'Secondary action to keep current plan and dismiss modal',
  },
});
